import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDate, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { MomentOrDate, momentToDate } from '@sb-helpers';
import { DateTimeService } from '@sb-shared/services/date-time.service';
import { subYears } from 'date-fns';

@Component({
    selector: 'sb-single-date-picker',
    templateUrl: './single-date-picker.component.html',
    styleUrls: ['./single-date-picker.component.scss'],
    standalone: false
})
export class SingleDatePickerComponent {
  @Input() set date(value: MomentOrDate) {
    this.ngbDate = this.toNgbDateStruct(value);
  }
  @Input() set minDate(value: MomentOrDate) {
    this.ngbMinDate = this.toNgbDateStruct(value || subYears(Date.now(), 100));
  }
  @Input() set maxDate(value: MomentOrDate) {
    this.ngbMaxDate = this.toNgbDateStruct(value);
  }
  @Input() disabled = false;
  @Input() showWeekNumbers = false;
  @Input() showFooter = false;
  @Input() firstDayOfWeek = 6;
  @Output() onChange: EventEmitter<{ startDate: MomentOrDate }> = new EventEmitter();

  @ViewChild('d') datepicker: NgbInputDatepicker;

  ngbDate: NgbDate;
  ngbMinDate: NgbDate;
  ngbMaxDate: NgbDate;

  constructor(private dateTime: DateTimeService) { }

  private toNgbDateStruct(inputDate: MomentOrDate): NgbDate | null {
    if (inputDate) {
      const input = momentToDate(inputDate);
      return new NgbDate(input.getFullYear(), input.getMonth() + 1, input.getDate());
    }
    return null;
  }

  change(event: NgbDate) {
    const date = this.dateTime.convertNgbDate(event);
    this.onChange.emit({
      startDate: this.dateTime.removeSeconds(date)
    });
  }

  setToday(): void {
    const today = new Date();
    this.ngbDate = new NgbDate(today.getFullYear(), today.getMonth() + 1, today.getDate());
    this.change(this.ngbDate);
    this.datepicker?.close();
  }

  clearDate(): void {
    this.ngbDate = null;
    this.onChange.emit({ startDate: null });
    this.datepicker?.close();
  }

  closePicker(): void {
    this.datepicker?.close();
  }
}
